export default __webpack_public_path__ + "static/media/exterior_color.8d6f1250.svg";